import React from "react";
import Login from '../../assets/images/Symfony/Eventi_connection.png';
import Artist from '../../assets/images/Symfony/Eventi_artist.png';
import Code from '../../assets/images/Symfony/Eventi_code_event.png';
import '../../assets/styles/Project.scss';

function Project_eventi() {
    return(
    <div className="projects-windows" id="projects">
        <h1>Eventi</h1>

        <p>Pour conclure le chapitre web du BUT informatique, 
            le projet consistait à créer un logiciel de gestion d'événements musicaux. 
            De ce projet est né Eventi, un site qui permet de gérer les événements, les artistes et les 
            utilisateurs. Ce projet a été réalisé avec Symfony, un framework qui nous a permis de gérer notre base 
            de données aisément et de construire le site en PHP plus facilement.</p><br></br>

            <img className="img" src={Login} alt="Page de connexion du site" />
            <p>Page de connexion</p><br></br>
        <h3>Les objectifs poursuivis</h3>
        <p>Afin de répondre à toutes les attentes, une liste détaillée de toutes les fonctionnalités et droits en 
            fonction du rôle de l'utilisateur a été dressée avant le début du projet :</p>
       <br></br>

        <p>Navigation</p>
        <ul>
            <li>La page d'accueil est publique et accessible à tous.</li>
            <li>Le reste de l'application est protégé et nécessite d'être connecté.</li>
            <li>La navigation est accessible sur toute la partie protégées de l'app.</li>
            <li>La navigation s'adapte à l'utilisateur connecté (admin ou user).</li><br></br>
        </ul>
            <p>Admin</p>
        <ul>
            <li>Le premier utilisateur a automatiquement le rôle ROLE_ADMIN, ensuite les autres utilisateurs sont ROLE_USER.</li>
            <li>L'admin est le seul à pouvoir créer et modifier des artistes.</li>
            <li>l'admin peut voir la liste des users.</li><br></br>
        </ul>

        <p>User</p>
        <ul>
            <li>Un utilisateur peut :</li>
            <li>voir la liste des artistes et des évènements.</li>
            <li>créer un événement.</li>
            <li>modifier un événement qu'il a créé (bouton visible uniquement pour lui).</li>
            <li>supprimer un événement qu'il a créé (bouton visible uniquement pour lui).</li>
            <li>s'inscrire et se désinscrire à un évènement.</li>
            <li>il est automatiquement inscrit à l'évènement qu'il a créé.</li>
            <li>voir la liste des événements auxquels il est inscrit.</li>
            <li>rechercher dans la liste des artistes par leur nom (utiliser les paramètres GET).</li>
            <li>filtrer la liste des événements par date (utilisez les paramètres GET).</li><br></br>
        </ul>
            <p>Artist</p>
        
        <ul>
            <li>Un artiste doit :</li>
            <li>Avoir un nom</li>
            <li>Avoir une description</li>
            <li>Avoir une image</li>
            <li>Sur la page d'un artiste, on peut voir :</li>
            <li>son nom</li>
            <li>sa description</li>
            <li>son image</li>
            <li>la liste des évènements auxquels il participe (avec le lien vers la page de l'évènement)</li><br></br>
        </ul>
        
        <p>Event</p>
        <ul>
            <li>Un évènement doit :</li>
            <li>Avoir un nom</li>
            <li>Avoir une date</li>
            <li>Avoir un artiste</li>
            <li>Sur la page d'un évènement, on peut voir :</li>
            <li>son nom</li>
            <li>sa date</li>
            <li>l'artiste associé (nom, image, lien vers la page de l'artiste)</li>
            <li>la liste des utilisateurs inscrits</li>
        </ul><br></br>

            <img className="img" src={Artist} alt="Liste des événements" />
            <p>Page des artistes</p><br></br>

        <h3>Les missions principales</h3>
        <p>Une fois entrés dans le vif du sujet, nous avons commencé par les étapes CRUD, c'est-à-dire ajouter, modifier, supprimer et lire toutes les informations ci-dessous dans une base de données. Nous avons ensuite mis en place les différentes pages qui composeront le site. Enfin, nous avons mis en place les autres fonctionnalités, comme ajouter une photo de l'artiste ou encore pouvoir mettre en favori les artistes et événements que vous souhaitez voir depuis l'écran d'accueil du site.
        Les compétences mobilisées (techniques, transversales et humaines)</p>
        <p>Les outils utilisés :</p>
        <p>Outils utilisés : Symfony / SQLite.</p>
        <p>Compétences transversales : Travail d'équipe, gestion du temps, cahier des charges, autonomie, bonnes pratiques de programmation, organisation.</p>
        <br></br>


            <img className="img" src={Code} alt="Code de l'ajout d'un événement sur le site Eventi" />
            <p>Code de l'ajout d'événement dans la base, sur le site </p><br></br>

        <h3>Les leçons tirés du projet</h3>

        <p>Au final, ce projet est une réussite puisque tous les points précédents ont été réalisés dans 
            les temps. Ainsi, Eventi est parfaitement opérationnel. Grâce à ce projet, nous avons mieux 
            compris les différentes étapes de création, de la phase de test jusqu'à la production. Nous 
            avons également pu découvrir le domaine du web, qui nous semblait encore abstrait il y a 
            quelque temps, et nous a permis de mieux nous familiariser avec ces technologies, et de mieux 
            nous préparer pour les futurs défis web.<br></br>
            Une première version sur Symfony a été faite. Cependant, Symfony ne reste qu'un framework back, 
            certes utile pour la gestion de la base de données, mais qui rend la présentation plutôt difficile.
            C'est pourquoi Eventi intègre sa propre API, qui est ensuite utilisée dans un site React, ce qui 
            nous permet de nous concentrer uniquement sur la façade du site.
            Au final, Eventi est disponible à la fois sur Symfony pour l'ajout et la modification d'artistes 
            ou d'événements, mais aussi en React pour afficher de façon plus simpliste les données du site.</p>
            <br></br>
        <p>Ce projet nous a permis de mieux comprendre les différentes étapes de création, de la phase de test jusqu'à la production. Nous avons également pu découvrir le domaine du web, qui nous semblait encore abstrait il y a quelque temps, et nous a permis de mieux nous familiariser avec ces technologies, et de mieux nous préparer pour les futurs défis web.</p>
        <br></br>

    </div>
    );
}

export default Project_eventi;